import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { VaultAccountType } from '@/types/myVaultTypes';
import { getVaultAccountDetailsPath } from '../_MyVaultAccountDetailsPage/path/path';
import { VaultCard } from './VaultCard/VaultCard';
import { ClosedVaultCard } from './VaultCard/ClosedVaultCard';
import { Fragment } from 'react';
import { VaultAccountsWrapper } from '../styles';

type VaultAccountsListType = {
  list: VaultAccountType[];
  onShare: (account: VaultAccountType) => void;
  onAddRail: (account: VaultAccountType, rail: string) => void;
  onClose: (account: VaultAccountType) => void;
  onReopen?: (account: VaultAccountType) => void;
};

export const VaultAccountsList = ({ list, onShare, onAddRail, onClose, onReopen }: VaultAccountsListType) => {
  const { navigateFrom } = useStatefulNavigation();

  const navigateToDetails = (id: string) => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.ViewDetailsVaultAccount);
    navigateFrom(getVaultAccountDetailsPath(id));
  };

  return (
    <VaultAccountsWrapper>
      {list.map((account) => {
        const isClosed = account.status === 'closed';

        return (
          <Fragment key={account.id}>
            {isClosed ? (
              <ClosedVaultCard account={account} onReopen={() => onReopen(account)} />
            ) : (
              <VaultCard
                account={account}
                onClose={() => onClose(account)}
                onShare={() => onShare(account)}
                onAddRail={(code) => onAddRail(account, code)}
                onView={() => navigateToDetails(account.id)}
              />
            )}
          </Fragment>
        );
      })}
    </VaultAccountsWrapper>
  );
};
